import { register } from './view'

import ArticleAccordion from '../views/article/accordion/accordion'
import ComponentCalendar from '../views/component/calendar/calendar'
import ComponentListing from '../views/component/listing/listing'
import ComponentSearch from '../views/component/search/search'
import ComponentTeaserGrid from '../views/component/teaser-grid/teaser-grid'

import 'lazysizes'
import './browser'

// Register components
register('calendar', ComponentCalendar)
register('listing', ComponentListing)
register('search', ComponentSearch)
register('teaser-grid', ComponentTeaserGrid)

// Register article parts
register('article-accordion', ArticleAccordion)
